export default "__VITE_ASSET__e220d508__"